import React from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import BotChat from '../../components/BotChat/BotChat';
import './ChatPage.css';

/**
 * Chat page for Peter Bot conversations
 * Route: /chat/:conversationId?token=xxx
 */
export default function ChatPage() {
  const { conversationId } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();

  const apiUrl = process.env.REACT_APP_PETER_BOT_API_URL || 'http://localhost:5002';

  if (!conversationId || !token) {
    return (
      <div className="chat-page">
        <div className="chat-page-error">
          <h2>Invalid Chat Link</h2>
          <p>This chat link is invalid or has expired. Please check your email for a valid link.</p>
          <button onClick={() => navigate('/dashboard')}>Go to Dashboard</button>
        </div>
      </div>
    );
  }

  return (
    <div className="chat-page">
      <div className="chat-page-container">
        <BotChat
          conversationId={conversationId}
          token={token}
          apiUrl={apiUrl}
          onClose={() => navigate('/dashboard')}
        />
      </div>
    </div>
  );
}

